import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useNavigate } from 'react-router-dom';

import Button from 'components/field/Button';
import Modal from 'components/global/Modal';
import Typography from 'components/global/Typography';
import { ModalActions, ModalContent, ModalTitle } from 'components/global/styled/Modal.styled';

import useLocale from 'hooks/useLocale';

import PATHS, { mergePaths } from 'utils/paths';

import * as S from './Notifications.styled';

/**
 * @author  @omerrkosar
 *
 */

const notificationPaths = [
	{ name: 'dataExport', path: PATHS.EXPORT_LOGS },
	{ name: 'export', path: PATHS.EXPORT_LOGS },
	{ name: 'importOrder', path: PATHS.IMPORT_LOGS },
	{ name: 'importNoSuccess', path: PATHS.IMPORT_LOGS },
	{ name: 'customerReview', path: mergePaths(PATHS.CUSTOMER_SERVICE, PATHS.CUSTOMER_SERVICE_FEEDBACKS) },
	{ name: 'lowStock', path: mergePaths(PATHS.INVENTORY_MAIN, PATHS.INVENTORY) },
	{ name: 'orderNeedConfirmation', path: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS) },
	{ name: 'deliveredOrder', path: mergePaths(PATHS.SHIPMENTS, PATHS.DELIVERED_ORDERS) },
	{ name: 'newOrder', path: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS) },
	{ name: 'newBulkOrder', path: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS) },
	{ name: 'agedOrder', path: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS) },
	{ name: 'orderSLABreach', path: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS) },
	{ name: 'shipmentCreated', path: mergePaths(PATHS.SHIPMENTS, PATHS.AWAITING_PICKUP) },
	{ name: 'shipmentFailed', path: mergePaths(PATHS.SYSTEM_LOGS, PATHS.SHIPMENT_ERROR_LOGS) },
	{ name: 'returnWaitingConfirmation', path: mergePaths(PATHS.SHIPMENTS, PATHS.RETURNED_ORDERS) },
	{ name: 'returnRequestReceived', path: mergePaths(PATHS.SHIPMENTS, PATHS.RETURNED_ORDERS) },
	{ name: 'syncOrderFailureNotFound', path: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS) },
	{ name: 'syncOrderFailureAuth', path: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS) },
	{ name: 'syncOrderFailureStatus', path: mergePaths(PATHS.SHIPMENTS, PATHS.PENDING_ORDERS) },
	{ name: 'creditRefundPeriod', path: mergePaths(PATHS.PAYMENTS, PATHS.CREDIT_TRANSACTIONS) }
];

const NotificationDetailsModal = NiceModal.create(({ selectedNotification }) => {
	const modal = useModal();
	const { getLocaleDateWithTime } = useLocale();
	const navigate = useNavigate();

	const isDetailsExist = !!notificationPaths.find((item) => item.name === selectedNotification.type)?.path;

	const navigateUser = (data) => {
		const item = notificationPaths.find((item) => item.name === data);
		item?.path && navigate(item.path);
		modal.remove(NotificationDetailsModal);
	};

	return (
		<Modal fullwidth maxWidth="small" className="modal-notificationDetails">
			<ModalTitle>
				<S.MessageHeader>
					{selectedNotification && (
						<Typography className="mb-3" fontWeight="500" variant="p2">
							{selectedNotification.header}
						</Typography>
					)}
					{selectedNotification && (
						<Typography fontWeight="300">{getLocaleDateWithTime(selectedNotification.date)}</Typography>
					)}
				</S.MessageHeader>
			</ModalTitle>
			<ModalContent className="p-1">
				{selectedNotification && (
					<Typography className="p-2 mt-1" fullWidth={true} noWrap={true}>
						{selectedNotification.content}
					</Typography>
				)}
			</ModalContent>
			<ModalActions>
				{isDetailsExist && (
					<Button
						label="seeDetails"
						variant="blueBorderless"
						onClick={() => {
							navigateUser(selectedNotification.type);
						}}
					/>
				)}
				<Button
					label="close"
					onClick={() => {
						modal.remove();
					}}
					variant="outline"
				/>
			</ModalActions>
		</Modal>
	);
});
export default NotificationDetailsModal;
